import { useAuth } from "@/lib/store";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, User as UserIcon, Heart, Package, Sparkles } from "lucide-react";
import { useEffect } from "react";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading, navigate]);

  if (loading || !user) {
    return <div className="p-24 text-center text-muted-foreground">Cargando…</div>;
  }

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-16" data-testid="account-page">
      <div className="grid md:grid-cols-4 gap-12">
        <aside className="space-y-2 font-mono-caps text-sm">
          <div className="flex items-center gap-3 pb-6 border-b border-border mb-6">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-12 h-12 rounded-full object-cover" />
            ) : (
              <div className="w-12 h-12 bg-navy text-cream flex items-center justify-center font-serif">{user.name?.[0]}</div>
            )}
            <div className="font-serif text-lg" data-testid="account-name">{user.name}</div>
          </div>
          <div className="flex items-center gap-3 py-2 text-foreground"><UserIcon strokeWidth={1.25} className="h-4 w-4" /> Perfil</div>
          <Link to="/account/wishlist" className="flex items-center gap-3 py-2 text-muted-foreground hover:text-foreground"><Heart strokeWidth={1.25} className="h-4 w-4" /> Favoritos</Link>
          <Link to="/account/pedidos" className="flex items-center gap-3 py-2 text-muted-foreground hover:text-foreground" data-testid="account-nav-orders"><Package strokeWidth={1.25} className="h-4 w-4" /> Pedidos</Link>
          <div className="flex items-center gap-3 py-2 text-muted-foreground"><Sparkles strokeWidth={1.25} className="h-4 w-4" /> Preferencias</div>
          {user.is_admin && (
            <Link to="/admin" className="flex items-center gap-3 py-2 text-royal hover:text-navy" data-testid="account-admin-link">
              <Sparkles strokeWidth={1.25} className="h-4 w-4" /> Panel admin
            </Link>
          )}
          <button onClick={doLogout} data-testid="logout-btn" className="flex items-center gap-3 py-2 text-muted-foreground hover:text-destructive mt-6">
            <LogOut strokeWidth={1.25} className="h-4 w-4" /> Cerrar sesión
          </button>
        </aside>

        <section className="md:col-span-3">
          <h1 className="font-serif text-4xl md:text-5xl mb-2">Hola, {user.name?.split(" ")[0]}</h1>
          <p className="text-muted-foreground" data-testid="account-email">{user.email}</p>

          <div className="grid sm:grid-cols-2 gap-6 mt-10">
            <div className="border border-border p-8">
              <div className="font-mono-caps text-xs text-muted-foreground">Total pedidos</div>
              <div className="font-serif text-4xl mt-2">0</div>
            </div>
            <div className="border border-border p-8">
              <div className="font-mono-caps text-xs text-muted-foreground">Puntos de fidelidad</div>
              <div className="font-serif text-4xl mt-2">0</div>
              <p className="text-xs text-muted-foreground mt-2">Cada compra suma puntos canjeables por muestras y descuentos.</p>
            </div>
          </div>

          <div className="border border-border p-10 mt-8">
            <div className="font-mono-caps text-xs text-muted-foreground">Preferencias olfativas</div>
            <h2 className="font-serif text-2xl mt-2">Aún sin definir</h2>
            <p className="text-sm text-muted-foreground mt-2">Explora nuestra guía y descubre qué familia refleja tu personalidad.</p>
            <Link to="/blog/guia-familias-olfativas" className="inline-block mt-6 border border-navy px-6 py-3 font-mono-caps hover:bg-navy hover:text-cream transition-colors">
              Descubrir mi familia
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
